// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
   width: 460px;
   height: 150px;
   padding: 12px 20px;
   box-sizing: border-box;
   border: 2px solid #ccc;
   border-radius: 4px;
   background-color: #f8f8f8;
   font-size: 16px;
   resize: none;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

:host::ng-deep .mat-dialog-content{
   overflow: unset !important;
}

body {
   overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/reject-task-dialog/reject-task-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,aAAa;GACb,kBAAkB;GAClB,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,yBAAyB;GACzB,eAAe;GACf,YAAY;AACf;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,gBAAgB;AACnB","sourcesContent":["textarea {\n   width: 460px;\n   height: 150px;\n   padding: 12px 20px;\n   box-sizing: border-box;\n   border: 2px solid #ccc;\n   border-radius: 4px;\n   background-color: #f8f8f8;\n   font-size: 16px;\n   resize: none;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n:host::ng-deep .mat-dialog-content{\n   overflow: unset !important;\n}\n\nbody {\n   overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
